import React from 'react'
import { Icon, mediaQueries } from '@centivo/react-components'
import styled, { useTheme } from 'styled-components'
import { useMediaContext } from 'src/context/responsive'

const SearchBarButtonTag = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: transparent;
  padding: 0.75rem 0 1rem 0;

  border-radius: 0.625rem;

  border-width: 1px;
  border-color: ${({ theme }) => theme.palette.brand.darkGreen};

  width: 13.125rem;

  &:not(:last-child) {
    margin-right: 1.313rem;
  }

  svg {
    color: ${({ theme }) => theme.palette.brand.darkGreen};
    margin-bottom: 0.5rem;
  }

  span {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 2.16rem;

    color: ${({ theme }) => theme.palette.brand.darkGreen};

    svg {
      margin: 0 0 0 1rem;
    }
  }

  :hover {
    cursor: pointer;
  }

  :focus {
    border-width: 0;
    box-shadow: 0px 0px 0px 6px ${({ theme }) => theme.palette.brand.newPurple};
    outline: 3px solid white;
  }

  &.selected {
    background-color: ${({ theme }) => theme.palette.brand.darkGreen};

    svg {
      color: ${({ theme }) => theme.palette.brand.lightGreen};
    }

    span {
      color: ${({ theme }) => theme.palette.brand.lightGreen};
    }
  }

  @media ${mediaQueries.mobile} {
    padding: 0.57rem 0 0.749rem 0;

    width: 9.97rem;

    &:not(:last-child) {
      margin-right: 1rem;
    }

    svg {
      margin-bottom: 0.38rem;
    }

    span {
      font-size: 1.139rem;
      line-height: 1.641rem;

      svg {
        margin: 0 0 0 0.438rem;
      }
    }
  }
`

interface SearchBarButtonProps
  extends Pick<React.HTMLProps<HTMLButtonElement>, 'onClick'> {
  selected: boolean
  icon: React.ReactElement
  title: string
}

export const SearchBarButtonSlice: React.FC<SearchBarButtonProps> = ({
  selected,
  icon,
  title,
  onClick,
}) => {
  const theme = useTheme()
  const { isMobileView } = useMediaContext()

  const ButtonIcon = () => icon

  return (
    <SearchBarButtonTag
      className={selected ? 'selected' : ''}
      onClick={onClick}
      aria-pressed={selected}
    >
      <ButtonIcon />
      <span>
        {title}
        {selected && (
          <Icon
            aria-hidden
            icon="slice-curly-arrow-down"
            size={isMobileView ? '1.188rem' : '1.5rem'}
            color={theme.palette.brand.lightGreen}
          />
        )}
      </span>
    </SearchBarButtonTag>
  )
}
